import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';
import { STEP_ENTER_PASSWORD } from '../scripts/constants';

const MultiPageGreeting = ({
  type, step, maskedName, multiPageGreeting, multiPagePassword,
}) => (type === 'multipage' && step === STEP_ENTER_PASSWORD ? (
  <div className="masked-name margin-1-b text-align-center">
    {' '}
    <Heading level={3} className="text-align-center" headingStyle="heading4">{`${multiPageGreeting} ${maskedName || ''}`}</Heading>
    <span className="text-align-center">{multiPagePassword}</span>
  </div>
) : '');

MultiPageGreeting.propTypes = {
  type: PropTypes.string,
  step: PropTypes.number,
  maskedName: PropTypes.string,
  multiPageGreeting: PropTypes.string,
  multiPagePassword: PropTypes.string,
};

MultiPageGreeting.defaultProps = {
  type: undefined,
};

export default MultiPageGreeting;
